/**
 * @generated SignedSource<<887ac4a9a1c8dc1794a196eeaa318766>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type CreateWidgetNoteInput = {
  flyerIntegrationId?: string | null;
  integrationId?: string | null;
  pages?: ReadonlyArray<CreateWidgetNotePageInput> | null;
  positionX: number;
  positionY: number;
  size: WidgetNoteSize;
  title: string;
};
export type CreateWidgetNotePageInput = {
  backgroundColor?: string | null;
  currentValue: string;
  fontSize: WidgetNoteFontSize;
  fontStyle: WidgetNoteFontStyle;
  imageScale?: number | null;
  imageTranslateX?: number | null;
  imageTranslateY?: number | null;
  includedInSlideshow: boolean;
  remoteImageURL?: string | null;
};
export type WANoteMutation$variables = {
  input: CreateWidgetNoteInput;
  storecastId: string;
};
export type WANoteMutation$data = {
  readonly dashboard: {
    readonly createWidgetNote: {
      readonly id: string;
    };
  };
};
export type WANoteMutation = {
  response: WANoteMutation$data;
  variables: WANoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetNote",
        "kind": "LinkedField",
        "name": "createWidgetNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WANoteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WANoteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "495f0d9939d4a4467bd63ee5f0afcc77",
    "id": null,
    "metadata": {},
    "name": "WANoteMutation",
    "operationKind": "mutation",
    "text": "mutation WANoteMutation(\n  $storecastId: ID!\n  $input: CreateWidgetNoteInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetNote(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36877f77e86eeb753e380313fcb99d5c";

export default node;
